<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import {cloneDeep} from 'lodash';

export default {
  props: {
    record: {},
  },
  data() {
    return {
      credentials: {
        employeeId: 0,
        isDisable: false,
        isAdmin: false,
        userName: null,
        email: null,
        password: null,
      },
      credentialModal: false,
      submitted: false,
      info: {
        id: 0,
        isAdmin: null,
        isDisable: null,
      },
      loading: false,
      emailUpdate: "",
      editEmail: false,
    };
  },
  created() {
    console.log(this.record);
    if (this.record.applicationUser) {
      this.info = {
        id: this.record.applicationUser.id,
        isAdmin: this.record.applicationUser.isAdmin,
        isDisable: this.record.applicationUser.isDisable,
      };
    }
  },
  validations: {
    credentials: {
      userName: { required },
      email: { required, email },
      password: { required, minLength: minLength(6) },
    },
    emailUpdate: { required, email },
  },
  methods: {
    displayModal(record) {
      this.onReset();
      this.credentials.employeeId = record.id;
      this.credentialModal = true;
    },
    onReset() {
      this.credentials = {
        employeeId: 0,
        isDisable: false,
        isAdmin: false,
        userName: null,
        email: null,
        password: null,
      };
    },
    onSubmit() {
      this.submitted = true;
      this.$v.credentials.$touch();
      if (this.$v.credentials.$invalid) {
        return;
      } else {
        this.pageLoader(true);
        this.$store
          .dispatch("auth/createAccount", this.credentials)
          .then((response) => {
            if (response.data.error) {
              // this.credentialModal = false;
              this.showToast(response.data.errorMessage, "error");
              this.pageLoader(false);
              return;
            }
            const url = `${window.location.origin}/confirmation`;
            this.$store
              .dispatch("auth/sendEmailConfirmation", {
                email: this.credentials.email,
                url: url,
              })
              .then(() => {
                this.$emit("close");
                this.credentialModal = false;
                this.pageLoader(false);
                this.showToast("Account created successfully", "success");
              })
              .catch((error) => {
                this.pageLoader(false);
                this.showToast("Cannot send confirmation to user. Please ask your administrator", "error");
              });
            // this.credentialModal = false;
            // this.onReset();
            // this.showToast("Account created successfully", "success");
          })
          .catch((error) => {
            this.pageLoader(false);
            this.showToast("Something went wrong. Failed to create account. Please contact your administrator", "error");
          });
      }
    },
    updateCredentials() {
      this.$store
        .dispatch("auth/updateCredentials", { id: this.info.id, data: this.info })
        .then((response) => {
          if (response.data.error) {
            this.showToast("Cannot update info. " + response.data.errorMessage, "error");
            return;
          }
          this.$emit("update-credentials", this.info);
          this.showToast("Account updated successfully", "success");
        })
        .catch((error) => {
          this.showToast("Something went wrong. Failed to update account. Please contact your administrator", "error");
        });
    },
    editEmailBtn(email) {
      this.$v.emailUpdate.$reset();
      this.emailUpdate = cloneDeep(email);
      this.editEmail = true;
    },
    updateEmail(){
      if(this.emailUpdate === this.record.email){
        this.editEmail = false;
        return;
      }
      this.submitted = true;
      this.$v.emailUpdate.$touch();
      if (this.$v.emailUpdate.$invalid) {
        return;
      }
      this.$store.dispatch("account/ChangeEmail", {
        email: this.emailUpdate,
        id: this.record.applicationUser.id,
      })
      .then((response) => {
        if (response.data.error) {
          this.showToast(response.data.errorMessage, "error");
          return;
        }
        this.record.email = cloneDeep(this.emailUpdate);
        this.record.emailConfirmed = false;
        // this.record.
        this.editEmail = false;
        this.showToast("Email updated successfully", "success");
      })
    },
    async sendEmailConfirm(row){
      const url = `${window.location.origin}/confirmation`;
      this.pageLoader(true);
      await this.$store
          .dispatch("auth/sendEmailConfirmation", {
              email: row.email,
              url: url,
          })
          .then(() => {
              this.showToast("Successfully sent to Email", "success");
          })
          .catch((error) => {
              this.showToast(
                  "Cannot send confirmation to user. Please ask your administrator",
                  "error"
              );
          });
      this.pageLoader(false);
    }
  },
};
</script>
<template>
  <div>
    <!-- <div class="card overflow-hidden"> -->
      <div class="bg-primary bg-soft">
        <div class="row">
          <div class="col-7">
            <div class="text-primary p-3">
              <h5 class="text-light mb-3">Account information</h5>
              <!-- <p>It will seem like simplified</p> -->
            </div>
          </div>
          <!-- <div class="col-5 align-self-end">
            <img src="assets/images/profile-img.png" alt="" class="img-fluid" />
          </div> -->
        </div>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-sm-7">
            <div class="avatar-md profile-user-wid mb-1">
              <div class="avatar-sm">
                <span class="avatar-title rounded-circle bg-soft bg-info text-info font-size-15"> {{ record.firstName.toUpperCase().charAt(0) }}{{ record.lastName.toUpperCase().charAt(0) }} </span>
              </div>
            </div>
            <div>
              <h5 class="font-size-15 mb-0">
                {{ `${record.firstName} ${record.lastName}` }}
              </h5>
              <small class="text-muted mb-0">{{ record.position }}</small>
            </div>
          </div>

          <div class="col-sm-5 text-end">
            <div class="pt-4 mt-4">
              <b-button size="sm" variant="primary" @click="displayModal(record)" v-if="!record.applicationUser">
                <i class="bx bx-user-plus font-size-16 align-middle me-2"></i>
                Create Account
              </b-button>
            </div>
          </div>
        </div>
        <div class="table-responsive mt-4">
          <table class="table mb-0 table-sm">
            <tbody>
              <tr>
                <th scope="row" class="align-middle">Office</th>
                <td class="text-warning">
                  {{ record.department.deliveryUnit ? record.department.deliveryUnit.name : "No record" }}
                </td>
              </tr>
              <tr>
                <th scope="row" class="align-middle">Department</th>
                <td class="text-warning">
                  {{ record.department ? record.department.departmentName : "No record" }}
                </td>
              </tr>
              <tr>
                <th scope="row" class="align-middle">Email</th>
                <td>
                    <div class="d-flex hover-toggle align-items-center" :class="{'justify-content-between': editEmail}">
                      <span class="text-warning" v-if="!editEmail">{{ record.email ? record.email : "No record" }}</span>
                    <div>
                      
                      <input type="text" class="form-control" v-model="emailUpdate" v-if="editEmail" :class="{'is-invalid': $v.emailUpdate.$error}"/>
                      <div v-if="submitted && $v.emailUpdate.$error" class="invalid-feedback">
                        <span v-if="!$v.emailUpdate.required">This value is required. </span>
                        <span v-if="!$v.emailUpdate.email">Please input valid email address. </span>
                      </div>
                    </div>
                    <a href="javascript:void(0);" class="text-success hover-content ms-1" v-if="!editEmail && record.applicationUser" @click="editEmailBtn(record.email)"><i class="bx bx-edit"></i></a>
                    <div class="d-flex align" v-if="editEmail">
                      <a href="javascript:void(0);" class="text-success ms-1 font-size-18 font-weight-bold" @click="updateEmail"><i class="bx bx-check"></i></a>
                      <a href="javascript:void(0);" class="text-danger ms-1 font-size-18 font-weight-bold" @click="editEmail = false"><i class="bx bx-x"></i></a>
                    </div>
                  </div>
                  <div v-if="!editEmail && !record.emailConfirmed && record.applicationUser">
                    <a href="javascript:void(0);" @click="sendEmailConfirm(record)"><small class="text-success"><i class="bx bx-send me-1"></i>Send Email Confirmation</small></a>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row" class="align-middle">Username</th>
                <td>
                  {{ record.applicationUser ? record.applicationUser.userName : "No Record Found" }}
                </td>
              </tr>
              <tr>
                <th scope="row">Admin</th>
                <td v-if="!record.applicationUser">No Record Found</td>
                <td v-else>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="isActiveInfo" v-model="info.isAdmin" @change="updateCredentials" />
                    <label class="form-check-label" for="isActiveInfo">{{ info.isAdmin ? "Yes" : "No" }}</label>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">Disabled</th>
                <td v-if="!record.applicationUser">No Record Found</td>
                <td v-else>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="isDisableInfo" v-model="info.isDisable" @change="updateCredentials" />
                    <label class="form-check-label" for="isDisableInfo">{{ info.isDisable ? "Yes" : "No" }}</label>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">Password changed</th>
                <td>
                  {{ record.applicationUser ? record.applicationUser.passwordChanged : "No Record Found" }}
                </td>
              </tr>
              <tr>
                <th scope="row">Email Verified</th>
                <td>
                  {{ record.emailConfirmed }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      <!-- </div> -->
    </div>
    <!-- Modal here -->
    <b-modal v-model="credentialModal" title="Create User Credentials" hide-footer no-close-on-backdrop>
      <div class="mb-3">
        <p>
          <strong>Create account for: </strong><span class="text-warning">{{ record.firstName }} {{ record.lastName }}</span>
        </p>
      </div>
      <hr />
      <b-overlay :show="loading" rounded="sm">
        <div class="mb-3">
          <label>Username</label>
          <b-input
            v-model="credentials.userName"
            placeholder="Enter Username..."
            :class="{
              'is-invalid': submitted && $v.credentials.userName.$error,
            }"
          ></b-input>
          <div v-if="submitted && $v.credentials.userName.$error" class="invalid-feedback">
            <span v-if="!$v.credentials.userName.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label>Email</label>
          <b-input
            v-model="credentials.email"
            placeholder="Enter Email..."
            :class="{
              'is-invalid': submitted && $v.credentials.email.$error,
            }"
          ></b-input>
          <div v-if="submitted && $v.credentials.email.$error" class="invalid-feedback">
            <span v-if="!$v.credentials.email.required">This value is required. </span>
            <span v-if="!$v.credentials.email.email">Please input valid email address. </span>
          </div>
        </div>
        <div class="mb-3">
          <label>Password</label>
          <b-input
            v-model="credentials.password"
            type="password"
            placeholder="Enter Password..."
            :class="{
              'is-invalid': submitted && $v.credentials.password.$error,
            }"
          ></b-input>
          <div v-if="submitted && $v.credentials.password.$error" class="invalid-feedback">
            <span v-if="!$v.credentials.password.required">This value is required. </span>
            <span v-if="!$v.credentials.password.minLength">Password should be at least 6 characters. </span>
          </div>
        </div>
        <div class="form-check form-switch mb-3">
          <input class="form-check-input" type="checkbox" id="isAdmin" v-model="credentials.isAdmin" />
          <label class="form-check-label" for="isAdmin">{{ credentials.isAdmin ? "Administrator" : "Not Administrator" }}</label>
        </div>
        <div class="form-check form-switch mb-3">
          <input class="form-check-input" type="checkbox" id="isActive" v-model="credentials.isDisable" />
          <label class="form-check-label" for="isActive">{{ credentials.isDisable ? "Active" : "Inactive" }}</label>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" @click="onSubmit">Save</button>
          <button type="button" class="btn btn-link">Close</button>
        </div>
      </b-overlay>
    </b-modal>
    <!-- Modal here -->
  </div>
</template>
